import { colors } from '../styles/fdsTheme';

/**
 * 비밀번호 관리 공용 — 계정관리(UserManagement)·계좌·전략 관리(AccountAdmin)가 같이 쓴다 (2026-11-03).
 * 서버: POST /api/v1/auth/users/{id}/temp-password (PwdPolicy) · GET /api/v1/auth/users 의 pwd* 필드
 */

/** 발급 직후 한 번만 보이는 임시 비밀번호 */
export interface IssuedPwd { userId: number; email: string; name: string; password: string; forceChange: boolean; expiresAt?: string | null; }

/** /api/v1/auth/users 행 중 비밀번호 상태에 쓰는 필드 */
export interface PwdInfo {
  role: number;
  pwdChangedAt?: string | null;
  pwdTempAt?: string | null;
  pwdTempExp?: string | null;
  pwdMustChange?: boolean;
  pwdExpired?: boolean;
  lockedUntil?: string | null;
}

/** UTC ISO → 'YYYY-MM-DD HH:mm' (현지) */
export const fmtT = (iso?: string | null) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

/** 비밀번호 상태 한 줄 — [표시, 색] */
export const pwdStatus = (u: PwdInfo): [string, string] => {
  if (u.lockedUntil && new Date(u.lockedUntil) > new Date()) return ['잠김', colors.up];
  if (u.pwdExpired) return ['임시 만료', colors.up];
  if (u.pwdMustChange) return [`임시 (~${fmtT(u.pwdTempExp).slice(5)})`, '#d97706'];
  if (u.pwdTempAt) return ['임시 (변경 강제 안 함)', colors.hint];
  return ['정상', '#16a34a'];
};

/** 사용자에게 보낼 안내문 — 메신저에 그대로 붙여 넣는다 */
export const deliveryText = (x: IssuedPwd) => [
  '[FDSAI] 임시 비밀번호 안내',
  `접속: ${window.location.origin}`,
  `아이디: ${x.email}`,
  `임시 비밀번호: ${x.password}`,
  x.forceChange && x.expiresAt ? `유효: ${fmtT(x.expiresAt)} 까지` : '',
  x.forceChange ? '로그인하면 바로 새 비밀번호로 바꿔 주세요.' : '',
].filter(Boolean).join('\n');

export const copy = (text: string, what: string) => {
  if (navigator.clipboard?.writeText) navigator.clipboard.writeText(text).then(() => alert(`${what} 복사했습니다.`), () => prompt('복사하세요', text));
  else prompt('복사하세요', text);   // http 접속이면 clipboard API 가 없다
};

/** 발급 확인 문구 — Viewer 는 공용 계정이라 변경을 강제하지 않는다(서버도 같은 규칙) */
export const tempPwdConfirm = (email: string, force: boolean, viewer: boolean) =>
  `${email} 에게 임시 비밀번호를 발급할까요?\n\n지금 비밀번호는 바로 못 쓰게 됩니다.` +
  (force ? '\n첫 로그인 때 새 비밀번호로 바꿔야 하고, 24시간 안에 로그인해야 합니다.' : '') +
  (viewer ? '\n\n⚠ Viewer 는 공용 계정입니다 — 이 계정을 쓰는 모든 사람에게 새 비밀번호를 알려야 합니다.' : '');
